import { StyleFilterPublicIcon } from '@/components/Icons/StyleFilterPublicIcon';
import StyleFilterDetailCard from '@/components/StyleFilterDetailCard/StyleFilterDetailCard';
import { TrackList } from '@/components/TrackList';
import { Badge } from '@/components/ui/badge';
import WithMobileHeader from '@/components/WithMobileHeader';
import { FilterDetailResponse, FilterGroupDetailResponse, StyleFilterArtistSFGenerationResponse } from '@/service/filter';
import { isEmpty } from 'lodash-es';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface StyleFilterDetailProps {
  id?: string | number | null;
  title?: string;
  imageUrl?: string;
  isPublic?: boolean;
  description?: string;
  stats?: {
    totalPurchases?: number;
    tracksGenerated?: number;
    secondsGenerated?: number;
    revenueGenerated?: number;
  };
  processedStatsData?: {
    label: string;
    value: string | undefined;
  }[];
  getStyleFilterArtistSFGenerationData?: StyleFilterArtistSFGenerationResponse;
  runGetStyleFilterArtistSFGeneration?: (page: number, pageSize: number, styleFilterGroupId: number, styleFilterId: number) => void;
  getStyleFilterGroupDetailData?: FilterGroupDetailResponse;
  styleFilterId?: number;
  handleSwitch?: (data: { value: number; id: number | undefined }) => void;
}

const StyleFilterDetailMobile: React.FC<StyleFilterDetailProps> = ({
  id,
  isPublic,
  processedStatsData,
  getStyleFilterArtistSFGenerationData,
  runGetStyleFilterArtistSFGeneration,
  getStyleFilterGroupDetailData,
  styleFilterId,
  handleSwitch,
}) => {
  const navigate = useNavigate();

  return (
    <WithMobileHeader>
      <div className="flex flex-col bg-[#111112] text-white min-h-screen">
        <div className="p-6 border-b border-[#242425]">
          <div
            className="hover:text-white flex items-center text-sm w-fit cursor-pointer"
            onClick={() => {
              navigate('/style-filter-admin');
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            All StyleFilters™
          </div>
        </div>

        <div className="px-3 py-6 flex flex-col gap-12 mx-4 bg-[#111112]">
          <div className="flex flex-col">
            <div>
              <StyleFilterDetailCard
                onRemove={() => undefined}
                onUse={() => undefined}
                title={getStyleFilterGroupDetailData?.data?.name}
                content={''}
                onSwitch={handleSwitch}
                sfId={getStyleFilterGroupDetailData?.data?.id}
                sfList={getStyleFilterGroupDetailData?.data?.sf_list}
                background={getStyleFilterGroupDetailData?.data?.album_cover}
                showButtons={false}
                disabled={true}
                isMarket={true}
                coverStyle={{
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  height: 348,
                  width: 230,
                  marginBottom: '25px',
                  boxShadow: `
                      0.6px 0.6px 0.6px rgba(0, 0, 0, 0.019),
                      1.4px 1.3px 1.5px rgba(0, 0, 0, 0.028),
                      2.6px 2.5px 2.9px rgba(0, 0, 0, 0.035),
                      4.7px 4.5px 5.2px rgba(0, 0, 0, 0.041),
                      8.8px 8.4px 9.3px rgba(0, 0, 0, 0.05),
                      21px 20px 21px rgba(0, 0, 0, 0.07)
                    `,
                }}
              />
            </div>
            <div>
              <div className="flex flex-col items-start gap-[21px]">
                {/* Public status badge */}
                <Badge className="flex bg-[#4CAF00]/20 text-[#4CAF00] items-center gap-1.5 px-4 py-3 border-contextual-colors-positive-accent rounded-3xl border-none">
                  <span>
                    <StyleFilterPublicIcon />
                  </span>
                  <span className="font-mono text-xs tracking-[-0.24px] leading-6">PUBLIC</span>
                </Badge>

                {/* Project title */}
                <h1 className="mt-2self-stretch font-normal text-contextual-colors-content-primary text-[42px] tracking-[-2.56px] leading-[42px]">
                  {getStyleFilterGroupDetailData?.data?.name}
                </h1>

                {/* Filter buttons */}
                {/* <div className="flex items-start">
                  <Button variant="outline" className="h-12 rounded-lg bg-black hover:bg-zinc-800 !border !border-[#242425] px-[18px] py-4">
                    <span className="text-[1rem] font-normal text-white hover:text-white text-base tracking-[-0.32px]">
                      Test StyleFilter
                    </span>
                  </Button>
                </div> */}
              </div>
            </div>
          </div>
          <div className="flex flex-row w-full">
            {isPublic && (
              <div className="w-full max-w-[680px] inline-flex flex-col justify-start items-start gap-6">
                {/* <div className="self-stretch flex flex-col justify-center items-start gap-6">
                <div className="self-stretch justify-end text-[#B7B7BD] text-[22px] font-normal leading-snug">Description</div>
                <div className="self-stretch justify-end text-xl font-normal leading-normal">
                  {getStyleFilterGroupDetailData?.data?.description}
                </div>
              </div> */}
                <div className="self-stretch inline-flex justify-between items-start">
                  <div className="justify-start text-[#71717A] text-Content-Tertiary text-xl font-normal leading-tight">
                    Total Purchases
                  </div>
                  <div className="justify-start text-xl font-normal leading-tight">{processedStatsData?.[0]?.value}</div>
                </div>
                <div className="self-stretch inline-flex justify-between items-start">
                  <div className="justify-start text-[#71717A] text-Content-Tertiary text-xl font-normal  leading-tight">
                    Tracks Generated
                  </div>
                  <div className="justify-start text-xl font-normal leading-tight">{processedStatsData?.[1]?.value}</div>
                </div>
                <div className="self-stretch inline-flex justify-between items-start">
                  <div className="justify-start text-[#71717A] text-Content-Tertiary text-xl font-normal leading-tight">
                    Seconds Generated
                  </div>
                  <div className="justify-start text-xl font-normal leading-tight">{processedStatsData?.[2]?.value}</div>
                </div>
                <div className="self-stretch inline-flex justify-between items-start">
                  <div className="justify-start text-[#71717A] text-Content-Tertiary text-xl font-normal leading-tight">
                    Income Generated
                  </div>
                  <div className="justify-start text-xl font-normal leading-tight">{processedStatsData?.[3]?.value}</div>
                </div>
              </div>
            )}
          </div>
          {!isEmpty(getStyleFilterArtistSFGenerationData?.data) && (
            <div className="flex flex-row">
              <section className="p-6 w-full rounded-2xl border border-[#242425]">
                <h2 className="text-[24px] text-white tracking-[-0.96px] leading-[24px] mb-6">Tracks using this StyleFilter</h2>
                <TrackList
                  ifNavigateInFilterTag={false}
                  trackListData={getStyleFilterArtistSFGenerationData?.data}
                  showSorter={false}
                  theme="dark"
                  count={getStyleFilterArtistSFGenerationData?.count}
                  onPageChange={(page) => {
                    runGetStyleFilterArtistSFGeneration?.(page, 10, Number(id), styleFilterId ?? 0);
                  }}
                  isSliceData={false}
                />
              </section>
            </div>
          )}
        </div>
      </div>
    </WithMobileHeader>
  );
};

export default StyleFilterDetailMobile;
